export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`)
  if (element) return element.getAttribute("content")
}

export function findElement(root, selector) {
  if (typeof root === "string") {
    selector = root
    root = document
  }
  return root.querySelector(selector)
}

export function toArray(value) {
  return Array.from(value)
}

export function removeElement(el) {
  el?.remove()
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling)
}
